import { Controller } from "@hotwired/stimulus"
import { render, cancel } from "timeago.js"

export default class extends Controller {
  connect() {
    this.dateShown = true
    this.date = this.element.innerText

    this.element.setAttribute("datetime", this.date)
    this.toggle()
  }

  toggle() {
    if (this.dateShown) {
      render(this.element)
    } else {
      cancel(this.element)
      this.element.innerText = this.date
    }

    this.dateShown = !this.dateShown
  }

}
